export class NonStandardizedMinting extends Error {}
